import { cn } from "@roman/shared/utils";

interface PrimaryButtonProps {
  content: React.ReactNode;
  onClick: () => void;
  className?: string;
  disabled?: boolean;
  isLoading?: boolean;
}

export const PrimaryButton = ({ content: text, onClick, className, disabled, isLoading }: PrimaryButtonProps) => {
  return (
    <button
      className={cn(
        "w-full py-3 px-2.5 rounded-md text-center transition-colors bg-primary text-white",
        disabled && "bg-disabled",
        className,
      )}
      type="button"
      onClick={onClick}
      disabled={disabled || isLoading}
    >
      <p className="text-base font-bold">{isLoading ? "Loading..." : text}</p>
    </button>
  );
};
